const EARTH_RADIUS_M = 6371000;
const TOLERANCE_CIRCLE_STEPS = 64;

/** Punkt w odległości distanceM metrów od (lat, lon), bearing w stopniach (0 = północ). */
export const destinationPoint = (lat, lon, distanceM, bearingDeg) => {
    const bearing = (bearingDeg * Math.PI) / 180;
    const lat1 = (lat * Math.PI) / 180;
    const lon1 = (lon * Math.PI) / 180;
    const angular = distanceM / EARTH_RADIUS_M;
    const lat2 = Math.asin(
        Math.sin(lat1) * Math.cos(angular) + Math.cos(lat1) * Math.sin(angular) * Math.cos(bearing)
    );
    const lon2 =
        lon1 +
        Math.atan2(
            Math.sin(bearing) * Math.sin(angular) * Math.cos(lat1),
            Math.cos(angular) - Math.sin(lat1) * Math.sin(lat2)
        );
    return { lat: (lat2 * 180) / Math.PI, lon: (lon2 * 180) / Math.PI };
};

/** Okrąg tolerancji jako polygon GeoJSON (metry, zgodne z backendem). */
export const buildToleranceCircleGeoJson = (lat, lon, radiusMeters, steps = TOLERANCE_CIRCLE_STEPS) => {
    if (!radiusMeters || radiusMeters <= 0) {
        return { type: 'FeatureCollection', features: [] };
    }
    const ring = [];
    for (let i = 0; i <= steps; i += 1) {
        const bearing = (360 * i) / steps;
        const p = destinationPoint(lat, lon, radiusMeters, bearing);
        ring.push([p.lon, p.lat]);
    }
    return {
        type: 'FeatureCollection',
        features: [
            {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: [ring],
                },
                properties: {},
            },
        ],
    };
};

export const getToleranceMeters = (localizationToleranceKm, defaultKm = 0.5) => {
    const km =
        localizationToleranceKm != null && localizationToleranceKm > 0
            ? Number(localizationToleranceKm)
            : defaultKm;
    return Math.round(km * 1000);
};
